<template>
    <div class="case_div">
        <!-- 创建一个文件选择输入框 -->
        <input type="file" id="fileInput" />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>
<style lang="less">
</style>